import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "@playbookai/api-clients";
import { kpiApi } from "../api/live-client.js";
import type { ManagedKpi } from "../api/types.js";
import { kpiKeys } from "./kpiQueryKeys.js";

/**
 * Activate a KPI (`POST /v1/kpis/:id/activate`). The server enforces the Owner +
 * current Target precondition and returns a typed `PlaybookApiError` when unmet;
 * the caller surfaces that. Refreshes lists (lifecycle badge) and the detail.
 */
export function useActivateKpi() {
  const config = useApiClient();
  const qc = useQueryClient();
  return useMutation<ManagedKpi, Error, string>({
    mutationFn: (kpiId) => kpiApi.activate(config, kpiId),
    onSuccess: (_data, kpiId) => {
      void qc.invalidateQueries({ queryKey: kpiKeys.lists() });
      void qc.invalidateQueries({ queryKey: kpiKeys.detail(kpiId) });
    },
  });
}
